export default __webpack_public_path__ + "static/media/nu.c4afdde3.svg";